enum actionTypes {
  'ADD_ALERT' = 'ADD_ALERT',
  'REMOVE_ALERT' = 'REMOVE_ALERT',
}

export default actionTypes;
